import React from "react";
import Modal from "react-modal";
import { Button } from "../../../common/Button/Button";
import { ControlledInput } from "../../../common/Input/Input";
import ModalContent from "../../../common/Modal/ModalContent";
import { X } from "react-feather";
import Checkbox from "../../../common/Checkbox/Checkbox";
import Spinner from "../../../common/Spinner/Spinner";
import Select from "../../../common/Select/Select";

Modal.setAppElement("#root");

export default function CancellationReasonModal({ neftDetails, ...props }) {
	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent className="select-cancellation-reason">
				{props.isLoading && <Spinner className="center" />}
				<div className="p-2 modal-header-bar">
					<span>Unsaved Information</span>
					<button
						type="button"
						className="close"
						aria-label="Close"
						onClick={props.toggleModal}
					>
						<X style={{ pointerEvents: "none" }} color="white" />
					</button>
				</div>
				<div
					className={`modal-body  ${
						props.isLoading && "set-opacity"
					}`}
				>
					<span>You have unsaved follow-up actions/follow-up date/Notes. Do you want to save and proceed?</span>
					
                    <div style={{clear:'both',margin:'10px'}}></div>
					<Button
						className={`${props.isDisabled}`}
						onClick={() => {
							props.onUpdateServiceRequest();
						}}
					>
						Yes
					</Button>
					<span
						className="ml-2 cursor-pointer"
						onClick={props.toggleModal}
					>
						Cancel
					</span>
				</div>
			</ModalContent>
		</Modal>
    );
}